import { useCallback, useEffect } from "react";
import { atom, useAtom } from "jotai";
import { useSessionId } from "@plansoft-configuration-renderer/framework";
const configurationLogEventState = atom([]);
const configurationLogEventSessionId = atom("");
export function useConfigurationLogEventState() {
    const sessionId = useSessionId();
    const [savedSessionId, setSessionId] = useAtom(configurationLogEventSessionId);
    const [logEvents, setLogEvents] = useAtom(configurationLogEventState);
    const clearLogs = useCallback(() => setLogEvents([]), [setLogEvents]);
    useEffect(() => {
        if (sessionId != savedSessionId) {
            setLogEvents([]);
            setSessionId(sessionId);
        }
    }, [sessionId, savedSessionId, setLogEvents, setSessionId]);
    return {
        logEvents,
        setLogEvents,
        clearLogs,
    };
}
//# sourceMappingURL=useConfigurationLogEventState.js.map